import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isPropValid from '@emotion/is-prop-valid';
import { Box, css, FormHelperText, styled, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { ResponseType } from './codecs';
import QuestionInput from './question';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ContentWrapper = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiBox-root:last-child {\n    margin-bottom: 0;\n  }\n"])));
var QuestionSubject = styled(Typography, {
  shouldForwardProp: isPropValid
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  margin-bottom: ", ";\n\n  & > * {\n    display: inline;\n    margin: 0;\n  }\n\n  ", "\n"])), function (p) {
  return p.theme.typography.fontWeightBold;
}, function (p) {
  return p.theme.spacing(1);
}, function (_ref) {
  var answerRequired = _ref.answerRequired,
      theme = _ref.theme;
  return answerRequired && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      &:after {\n        content: '*';\n        margin-left: ", ";\n        color: ", ";\n      }\n    "])), theme.spacing(0.5), theme.palette.error.main);
});
export var QuestionWrapper = function QuestionWrapper(_ref2) {
  var _ref2$question = _ref2.question,
      subject = _ref2$question.subject,
      required = _ref2$question.required,
      verticalSpacing = _ref2.verticalSpacing,
      hasError = _ref2.hasError,
      children = _ref2.children,
      id = _ref2.id;
  return /*#__PURE__*/_jsxs(Box, {
    id: id,
    sx: {
      mb: verticalSpacing,
      width: 1
    },
    "data-element": "Box",
    "data-component": "QuestionWrapper",
    "data-source-file": "question-inputs.tsx",
    children: [/*#__PURE__*/_jsx(Translation, {
      "data-element": "Translation",
      "data-component": "QuestionWrapper",
      "data-source-file": "question-inputs.tsx",
      children: function children(t) {
        return /*#__PURE__*/_jsx(QuestionSubject, {
          sx: {
            color: function color(t) {
              return hasError ? t.palette.error.main : t.palette.text.primary;
            }
          },
          answerRequired: required,
          variant: "h4",
          dangerouslySetInnerHTML: {
            __html: t(subject)
          }
        });
      }
    }), children]
  });
};

var PublicFieldHelperText = function PublicFieldHelperText(props) {
  return /*#__PURE__*/_jsx(FormHelperText, _objectSpread(_objectSpread({}, props), {}, {
    "data-element": "FormHelperText",
    "data-component": "PublicFieldHelperText",
    "data-source-file": "question-inputs.tsx"
  }));
};

export var QuestionInputs = function QuestionInputs(_ref3) {
  var questions = _ref3.questions,
      questionForm = _ref3.questionForm,
      _ref3$verticalSpacing = _ref3.verticalSpacing,
      verticalSpacing = _ref3$verticalSpacing === void 0 ? 4 : _ref3$verticalSpacing,
      questionRef = _ref3.questionRef;
  return /*#__PURE__*/_jsx(ContentWrapper, {
    ref: questionRef,
    "data-element": "ContentWrapper",
    "data-component": "QuestionInputs",
    "data-source-file": "question-inputs.tsx",
    children: questions.map(function (question) {
      return ResponseType.is(questionForm.getValues(question.id)) && /*#__PURE__*/_jsxs(QuestionWrapper, {
        id: question.id,
        question: question,
        verticalSpacing: verticalSpacing,
        hasError: !!questionForm.formState.errors[question.id],
        children: [/*#__PURE__*/_jsx(QuestionInput, {
          question: question,
          questionForm: // @ts-expect-error - `T` type should be assignable to the base type
          //  `Record<string, ResponseFormType>` here. However, the `T` type is
          //  being used both covariantly and contravariantly in `UseFormReturn`
          //  type, thus making it invariant and thus causing an error here.
          questionForm
        }), question.responseIsPublic && /*#__PURE__*/_jsx(PublicFieldHelperText, {
          children: /*#__PURE__*/_jsx(Translation, {
            children: function children(t) {
              return t('Your response will be shown on your profile');
            }
          })
        })]
      }, question.id);
    })
  });
};